import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from 'app/components/atoms/Icon/Icon';

const SearchBoxContainer = styled.div`
    display: flex;
    align-items: center;
    border-radius: 24px;
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    max-width: 500px;
    width: 100%;
    margin: 0 16px;
    margin-left: 10%;

      &.custom-search-box {
         background-color: ${({ theme }) => theme.material.colors.appHeader.searchBgColor};
    }

    &:hover {
        background-color: ${({ theme }) => theme.material.colors.appHeader.searchHover};
    }

    @media (max-width: 768px) {
        max-width: 200px;
        margin: 0 8px;
    }
`;

const SearchIcon = styled(Icon)`
    margin-right: 12px;
    flex-shrink: 0;
`;

const SearchPlaceholder = styled.span`
    color: ${({ theme }) => theme.material.colors.text.secondary};
    font-size: 14px;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const SearchBox = ({ onClick, placeholder = 'Search...' }) => {
    return (
        <SearchBoxContainer className="custom-search-box" onClick={onClick} role="button" tabIndex={0} aria-label="Open search">
            <SearchIcon name="magnify" size="sm" />
            <SearchPlaceholder>{placeholder}</SearchPlaceholder>
        </SearchBoxContainer>
    );
};

SearchBox.propTypes = {
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

export default SearchBox;

